<template>
  <div
    class="avatar d-flex align-items-center justify-content-center" 
    :class="getSize(size)"
    :style="!img ? getAvatarStyle() : ''"
  >
    <img
      v-if="img"
      :src="img"
      :alt="alt"
      :class="[getClasses(shadow, circular, borderRadius)]"
    />
    <span v-else class="initials" :class="[getClasses(shadow, circular, borderRadius)]">
      {{ getInitials(alt) }}
    </span>
  </div>
</template>

<script>
export default {
  name: "MaterialAvatar",
  props: {
    img: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "User",
    },
    color: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md",
    },
    shadow: {
      type: String,
      default: "",
    },
    borderRadius: {
      type: String,
      default: "",
    },
    circular: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSize(size) {
      return size ? `avatar-${size}` : null;
    },
    getClasses(shadow, circular, borderRadius) {
      let shadowValue = shadow ? (shadow === "regular" ? "shadow" : `shadow-${shadow}`) : "";
      let circularValue = circular ? "rounded-circle" : "";
      let borderRadiusValue = borderRadius ? `border-radius-${borderRadius}` : "";
      return `${shadowValue} ${circularValue} ${borderRadiusValue}`;
    },
    getInitials(name) {
      if (!name) return "U";
      const words = name.toUpperCase().trim().split(" ");
      return words.length > 1
        ? words[0][0] + words[1][0]
        : words[0][0];
    },
    getAvatarStyle() {
      return {
        backgroundColor: this.color || this.getRandomColor(),
        color: "#fff",
      };
    },
    getRandomColor() {
      const colors = ["#FF5733", "#33A1FF", "#FF33A8", "#FFB833", "#33FF57", "#8D33FF", "#FF3388"];
      return colors[Math.floor(Math.random() * colors.length)];
    }
  }
};
</script>

<style scoped>
.initials {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 1.2em;
}
</style>
